import { c as _c } from "react/compiler-runtime";
import { TransitionProperties, TransitionState } from "@website/ui/transition/transition.types";
import { useEffect, useEffectEvent, useState } from "react";
type InternalTransitionState = TransitionState | "unmounted";
const getTimeout = (timeout: TransitionProperties["timeout"], state: "entering" | "exiting") => typeof timeout === "number" ? timeout : state === "entering" ? timeout.enter : timeout.exit;
export const Transition = t0 => {
  const $ = _c(32);
  const {
    in: t1,
    timeout,
    unmountOnExit: t2,
    mountOnEnter: t3,
    children,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    enter: t4,
    exit: t5
  } = t0;
  const inProperty = t1 === undefined ? false : t1;
  const unmountOnExit = t2 === undefined ? false : t2;
  const mountOnEnter = t3 === undefined ? false : t3;
  const enter = t4 === undefined ? true : t4;
  const exit = t5 === undefined ? true : t5;
  let t6;
  if ($[0] !== inProperty || $[1] !== mountOnEnter) {
    t6 = () => mountOnEnter && !inProperty ? "unmounted" : "exited";
    $[0] = inProperty;
    $[1] = mountOnEnter;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const [state, setState] = useState(t6);
  let t7;
  if ($[3] !== enter || $[4] !== exit || $[5] !== inProperty || $[6] !== onEnter || $[7] !== onEntering || $[8] !== onExit || $[9] !== onExiting || $[10] !== state) {
    t7 = () => {
      if (inProperty && (state === "unmounted" || state === "exited")) {
        if (!enter) {
          setState("entered");
          return;
        }
        onEnter?.();
        setState("entering");
        onEntering?.();
        return;
      }
      if (!inProperty && state === "entered") {
        if (!exit) {
          setState("exited");
          return;
        }
        onExit?.();
        setState("exiting");
        onExiting?.();
      }
    };
    $[3] = enter;
    $[4] = exit;
    $[5] = inProperty;
    $[6] = onEnter;
    $[7] = onEntering;
    $[8] = onExit;
    $[9] = onExiting;
    $[10] = state;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const startTransition = useEffectEvent(t7);
  let t8;
  if ($[12] !== onEntered || $[13] !== onExited) {
    t8 = transitionState => {
      if (transitionState === "entering") {
        setState("entered");
        onEntered?.();
      } else {
        setState("exited");
        onExited?.();
      }
    };
    $[12] = onEntered;
    $[13] = onExited;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const finishTransition = useEffectEvent(t8);
  let t9;
  if ($[15] !== startTransition) {
    t9 = () => {
      startTransition();
    };
    $[15] = startTransition;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== inProperty || $[18] !== state) {
    t10 = [inProperty, state];
    $[17] = inProperty;
    $[18] = state;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== finishTransition || $[21] !== state || $[22] !== timeout) {
    t11 = () => {
      if (state !== "entering" && state !== "exiting") {
        return;
      }
      const timeoutId = setTimeout(() => finishTransition(state), getTimeout(timeout, state));
      return () => clearTimeout(timeoutId);
    };
    $[20] = finishTransition;
    $[21] = state;
    $[22] = timeout;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== state || $[25] !== timeout) {
    t12 = [state, timeout];
    $[24] = state;
    $[25] = timeout;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  useEffect(t11, t12);
  if (state === "unmounted" || unmountOnExit && state === "exited") {
    return null;
  }
  let t13;
  if ($[27] !== children || $[28] !== state) {
    t13 = children(state);
    $[27] = children;
    $[28] = state;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = <>{t13}</>;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};